export default "__VITE_ASSET__V9aEat9G__"